import { actions as arcAdvertisersActions } from 'domains/arcAdvertisers'

export const fetchArcAdvertisers = (payload) => arcAdvertisersActions.fetchArcAdvertisers(payload)

export const fetchArcAdvertiserDetails = (payload) => arcAdvertisersActions.fetchArcAdvertiserDetails(payload)

export const createArcAdvertiser = (payload) => arcAdvertisersActions.createArcAdvertiser(payload)

export const updateArcAdvertiser = (payload) => arcAdvertisersActions.updateArcAdvertiser(payload)

export const deleteArcAdvertiser = (payload) => arcAdvertisersActions.deleteArcAdvertiser(payload)

export const resetFiltersAndSorter = () => arcAdvertisersActions.saveFiltersAndSorter({
  search: '',
  filters: {},
  sorter: {}
})